import React, { memo } from "react";

const SitePreview = () => {

	return (
		<iframe
			id="astra-starter-templates-preview"
			height="100%"
			width="100%"
			src={starterTemplates.site_url}
		/>
	);
}

export default memo(SitePreview);
